export const customFieldTagRegex = /(?<=\[)(?:(?!\]).)*(?=\])/g;
